import {FC, ReactNode} from 'react';
import {Outlet} from 'react-router-dom';
import {JwtScope} from '@common/types/authentication/authentication.types';
import {useScopedJwt} from '@common/hooks/auth/useScopedJwt';

interface Props {
  jwtScope: JwtScope;
  children?: ReactNode;
}

const ScopedJwtGuard: FC<Props> = ({jwtScope, children}) => {
  const {scopedJwt} = useScopedJwt(jwtScope);

  if (!scopedJwt) {
    return null;
  }

  return children ? children : <Outlet />;
};

export default ScopedJwtGuard;
